import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { putField } from "../../../../../utils/form";
import store from "../../../../../store";
import { callRequestStatus } from "../../../storage-location/request/request.section";
import { callDepartment, callReleaseResult, callRequestDoc } from "../request/request.section";
import moment from "moment";

export const callUserObjective = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery }).then(items => items.filter(item => ["1", "2"].includes(item.key)));

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.release.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1"
                    ? record.refUserCompany?.companyNameTh
                    : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "approveCode",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.release.refInspection.expireDate"),
            dataIndex: "refInspection.expireDate",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.release.refInspection.invoiceCode"),
            dataIndex: "products.refInspectionProduct.refInformProduct.invoiceCode",
            align: "center",
            customRender: ({ record }) => {
                const labels = record.products?.map(d => {
                    const informProduct = d.refInspectionProduct?.refInformProduct;
                    return record.products?.length > 1 ?
                        <div>{`(${informProduct?.invoiceSeq}) ${informProduct?.invoiceCode}`}<div>{moment(informProduct?.invoiceDate)?.format("DD/MM/YYYY")}</div></div>
                        : <div>{informProduct?.invoiceCode}<div>{moment(informProduct?.invoiceDate)?.format("DD/MM/YYYY")}</div></div>
                });
                return <div>{...labels}</div>
            }
        }),
        createColumnDate({
            title: () => i18n.global.t("model.release.refInspection.inspectionDatetime"),
            dataIndex: "refInspection.inspectionDatetime",
            align: "center",
            format: "DD/MM/YYYY HH:mm"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.release.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refDepartment.id" },
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.release.refInspection.refRequestDoc"),
            dataIndex: "refInspection.refRequestDoc.value",
            inputProp: () => ({ list: ({searchQuery}) => callRequestDoc({ searchQuery }).then(d => d.filter(doc=>["02", "16", "17", "18", "19"].includes(doc?.key))), optLabel: "value" }),
            search: { name: "refInspection.refRequestDoc.id" },
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.release.refResult"),
            dataIndex: "refResult.value",
            inputProp: () => ({ list: callReleaseResult, optLabel: "value", }),
            search: { name: "refResult.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({
                list: ({searchQuery}) => callRequestStatus({ searchQuery }),
                optLabel: "value"
            }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
